// A profile link that survives a new tab or a paste, unlike one carrying the id in history state.
export const userProfilePath = (userId: string) =>
  `/users/profile?userId=${encodeURIComponent(userId)}`;

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  TENANTS: "/tenants",
  TEMPLATES: "/templates",
  BRANDS: "/brands",
  BASE_LANGUAGES: "/base/languages",
  BASE_CURRENCIES: "/base/currencies",
  BASE_COUNTRIES: "/base/countries",
  BASE_TRANSLATIONS: "/base/translations",
  ROLES: "/users/roles",
  USERS: "/users",
  AGENTS: "/users/agents",
  USER_PROFILE: "/users/profile",
  SESSION: "/security/sessions",
  SECURITY_AUDIT_LOG: "/security/audit-log",
  SECURITY_BACKUPS: "/security/backups",
  SECURITY_LOGIN_HISTORY: "/security/login-history",
  SECURITY_TRACKING_WHITELIST: "/security/tracking-whitelist",
  SECURITY_GEO_ACCESS: "/security/geo-access",
  SECURITY_SERVER_SWITCHES: "/security/server-switches",
  PAYMENT_PROVIDERS: "/payment/providers",
  PAYMENT_WITHDRAWALS: "/payment/withdrawals",
  PAYMENT_METHOD_RULES: "/payment/method-rules",
  PAYMENT_BALANCE_ADJUSTMENTS: "/payment/balance-adjustments",
  PAYMENT_SKY_SETTINGS: "/payment/sky-settings",
  PAYMENT_SWAP_APPROVALS: "/payment/swap-approvals",
  COMPLIANCE_KYC: "/compliance/kyc",
  COMPLIANCE_RISK: "/compliance/risk",
  COMPLIANCE_CHAT: "/compliance/chat",
  COMPLIANCE_BET_LIMITS: "/compliance/bet-limits",
  BRAND_SIDEBAR: "/brand/sidebar",
  BRAND_BANNER: "/brand/banner",
  BRAND_FOOTER_LIST: "/brand/footer/list",
  BRAND_FOOTER_ITEM: "/brand/footer/item",
  BRAND_FOOTER_IMAGE: "/brand/footer/image",
  GAME_AGGREGATORS: "/game/aggregators",
  GAME_CATEGORIES: "/game/categories",
  GAME_TYPES: "/game/types",
  GAME_PROVIDERS: "/game/providers",
  GAME_BOTS: "/game/bots",
  GAMES: "/game/games",
  CMS_SIDEBAR: "/cms/sidebar",
  CMS_BANNER: "/cms/banner",
  CMS_FAQ: "/cms/faq",
  TEMPLATE_FOOTER_LIST: "/template/footer/list",
  TEMPLATE_FOOTER_ITEM: "/template/footer/item",
  TEMPLATE_FOOTER_IMAGE: "/template/footer/image",
  CRM_NOTIFICATION: "/crm/notification",
  CRM_SUPPORT_HISTORY: "/crm/support-history",
  CRM_HELP_CATEGORIES: "/crm/help-center/categories",
  CRM_HELP_ARTICLES: "/crm/help-center/articles",
  CRM_SITE_PAGES: "/crm/site-pages",
  CRM_SUPPORT_WIDGET: "/crm/support-widget",
  REPORT_ANALYTICS: "/report/analytics",
  REPORT_SOLVENCY: "/report/solvency",
  REPORT_GAME: "/report/game",
  REPORT_PAYMENT: "/report/payment",
  REPORT_SCHEDULES: "/report/schedules",
  REPORT_WALLET_LEDGER: "/report/wallet-ledger",
  REPORT_BONUS_GRANT: "/report/bonus-grant",
  REPORT_BONUS_WALLET_LEDGER: "/report/bonus-wallet-ledger",
  REPORT_DAILY_SPIN: "/report/daily-spin",
  REPORT_WAGER_RACE: "/report/wager-race",
  REPORT_SLOT_BATTLE: "/report/slot-battle",
  REPORT_RAFFLE: "/report/raffle",
  REPORT_RAKEBACK: "/report/rakeback",
  REPORT_VIP_BOOST: "/report/vip-boost",
  REPORT_DAILY_CHECKIN: "/report/daily-checkin",
  REPORT_MISSION: "/report/mission",
  REPORT_LOYALTY_STORE: "/report/loyalty-store",
  REPORT_TIPPING: "/report/tipping",
  PROMOTION_TEMPLATE: "/promotion/template",
  PROMOTION_VIP_LIST: "/promotion/vip",
  PROMOTION_VIP_SOURCES: "/promotion/vip-sources",
  PROMOTION_DAILY_SPIN: "/promotion/daily-spin",
  PROMOTION_JACKPOT: "/promotion/jackpot",
  PROMOTION_WAGER_RACE: "/promotion/wager-race",
  PROMOTION_CHALLENGE: "/promotion/challenge",
  PROMOTION_RAFFLE: "/promotion/raffle",
  PROMOTION_RAKEBACK: "/promotion/rakeback",
  PROMOTION_VIP_BOOST: "/promotion/vip-boost",
  PROMOTION_VIP_HOST: "/promotion/vip-host",
  PROMOTION_DAILY_CHECKIN: "/promotion/daily-checkin",
  PROMOTION_MISSION: "/promotion/mission",
  PROMOTION_LOYALTY_STORE: "/promotion/loyalty-store",
  PERMISSION_SIDEBAR: "/permission/sidebar",
  PERMISSION_GROUPS: "/permission/groups",
  PERMISSION_FUNCTIONS: "/permission/functions",
  PERMISSION_ICONS: "/permission/icons",
  FORBIDDEN: "/403",
  NOT_FOUND: "*",
};
